import { render, staticRenderFns } from "./PaymentIcons.vue?vue&type=template&id=ddc07738&scoped=true&"
import script from "./PaymentIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentIcons.vue?vue&type=script&lang=js&"
import style0 from "./PaymentIcons.vue?vue&type=style&index=0&id=ddc07738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc07738",
  null
  
)

export default component.exports